import rfdc from 'rfdc';
export const copy = function (data) {
  let {
    time = false,
    allowEnumerablesOnPrototype = true,
    trackReferences = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const clone = rfdc({
    proto: allowEnumerablesOnPrototype,
    circles: trackReferences
  });
  if (time) {
    const start = performance.now();
    const copied = clone(data);
    const end = performance.now();
    const totalTime = end - start;
    return {
      start,
      end,
      totalTime,
      data: copied
    };
  }
  return {
    data: clone(data)
  };
};
//# sourceMappingURL=copy.js.map